import OldAnalyticsHome from '../components/OldAnalyticsHome';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';

import { checkPermission } from 'utils/credentials';
import { ROLES } from '../../../../consts';

import {
  createCondition,
  updateListPredicates,
  fetchUsersInteraction,
  fetchListChannels,
  fetchListChannelEvents,
  fetchListQuestions,
  fetchUpdateDataAnalytics,
  fetchInteractionData,
  fetchFilterInteractionStatistics,
  fetchFilterData,
  combineConditions,
  filterOption,
  createReport,
} from '../modules';

const mapDispatchToProps = dispatch => ({
  createCondition(field, operator, value, question, date, picks) {
    dispatch(createCondition(field, operator, value, question, date, picks));
  },
  updateListPredicates(setence) {
    dispatch(updateListPredicates(setence));
  },
  fetchUsersInteraction(listUsersWithData, from, to, userAnonymous, hideDeletedUsers) {
    dispatch(
      fetchUsersInteraction(listUsersWithData, from, to, userAnonymous, hideDeletedUsers)
    );
  },
  fetchListChannels() {
    dispatch(fetchListChannels);
  },
  fetchListChannelEvents(channelId) {
    dispatch(fetchListChannelEvents(channelId));
  },
  fetchListQuestions(interactionId) {
    dispatch(fetchListQuestions(interactionId));
  },
  fetchUpdateDataAnalytics() {
    dispatch(fetchUpdateDataAnalytics());
  },
  fetchInteractionData(interactionId) {
    dispatch(fetchInteractionData(interactionId));
  },
  fetchFilterInteractionStatistics(interactionId) {
    dispatch(fetchFilterInteractionStatistics(interactionId));
  },
  fetchFilterData(query) {
    dispatch(fetchFilterData(query));
  },
  combineConditions(listConditions) {
    dispatch(combineConditions(listConditions));
  },
  filterOption(interaction, question, option, preview) {
    dispatch(filterOption(interaction, question, option, preview));
  },
  createReport(event) {
    dispatch(createReport(event));
  },
});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
    listConditions: _.get(state, 'analytics.listConditions', []),
    listInteractions: _.get(state, 'analytics.listInteractions', []),
    listData: _.get(state, 'analytics.listData', null),
    listPredicates: _.get(state, 'analytics.listPredicates', []),
    listUsersInteraction: _.get(state, 'analytics.listUsersInteraction', []),
    listChannels: _.get(state, 'analytics.listChannels', []),
    listChannelEvents: _.get(state, 'analytics.listChannelEvents', []),
    listUsersWithData: _.get(state, 'analytics.listUsersWithData', []),
    listQuestions: _.get(state, 'analytics.listQuestions', []),
    listOperators: _.get(state, 'analytics.listOperators', []),
    listDataFilter: _.get(state, 'analytics.listDataFilter', []),
    listOriginalListUsers: _.get(state, 'analytics.listOriginalListUsers', []),
    usersWeek: _.get(state, 'analytics.usersWeek', 0),
    interactionStatistics: _.get(state, 'analytics.interactionStatistics', null),
    eventStatistics: _.get(state, 'analytics.eventStatistics', null),
    validInteractions: _.get(state, 'analytics.validInteractions', 0),
    usersRate: _.get(state, 'analytics.usersRate', 0),
    usersWithData: _.get(state, 'analytics.usersWithData', 0),
    csvData: _.get(state, 'analytics.csvData', []),
  };
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('selectedTab', 'updateSelectedTab', 0),
  withState('showDeletedUsers', 'setShowDeletedUsers', false),
  withState('showAnonymousUsers', 'setShowAnonymousUsers', true),
  withState('customFilter', 'setCustomFilter', false),
  withState(
    'listUsersInteractionCustomFiltered',
    'setListUsersInteractionCustomFiltered',
    []
  ),
  withState('fromDate', 'setFromDateFilterUser', ''),
  withState('untilDate', 'setUntilDateFilterUser', ''),

  withHandlers({
    onChangeTab: props => (evt, value) => {
      props.updateSelectedTab(value);
    },
  }),
  lifecycle({
    async componentDidUpdate(prevProps) {
      const { listConditions } = this.props;

      checkPermission(this, ROLES.ANALYTICS);

      if (!_.isEqual(listConditions, prevProps.listConditions)) {
        this.props.combineConditions(listConditions);
      }
    },
    componentDidMount() {
      this.props.fetchUpdateDataAnalytics();
    },
  })
);

export default enhance(OldAnalyticsHome);
